import {
  isTerminalToolName,
  type ExternalToolResult,
  type PortalToolHandlerResultPayload,
  type PortalToolResultStatus,
  type TerminalFailureKind,
  type TerminalOutputItem,
} from '@terra/shared-dto-chat-types';

export type PortalToolHandlerParams = {
  input: Record<string, unknown>;
  toolCallId: string;
  batchId: string;
  applicationId: string;
  sessionId: string;
};

export type PortalToolHandlerResult = {
  status: PortalToolResultStatus;
  result: PortalToolHandlerResultPayload;
};

export type PortalToolHandler = (
  params: PortalToolHandlerParams,
) => Promise<PortalToolHandlerResult>;

export function buildPortalToolErrorResult({
  toolName,
  toolCallId,
  batchId,
  message,
  failureKind,
}: {
  toolName: string;
  toolCallId: string;
  batchId: string;
  message: string;
  failureKind?: TerminalFailureKind;
}): PortalToolHandlerResult {
  if (isTerminalToolName(toolName)) {
    const terminalResult: TerminalOutputItem = {
      batchId,
      toolCallId,
      command: '',
      exitCode: -1,
      output: message,
      outputLength: message.length,
      ...(failureKind === undefined ? {} : { failureKind }),
    };

    return {
      status: 'error',
      result: terminalResult,
    };
  }

  return {
    status: 'error',
    result: { message },
  };
}

export function buildPortalExternalToolResult({
  batchId,
  chatId,
  toolCallId,
  toolName,
  handlerResult,
}: {
  batchId: string;
  chatId: string;
  toolCallId: string;
  toolName: string;
  handlerResult: PortalToolHandlerResult;
}): ExternalToolResult {
  return {
    batchId,
    chatId,
    toolCallId,
    toolName,
    status: handlerResult.status,
    result: handlerResult.result,
  };
}
